import { useEffect, useRef } from "react";
import { THEHUB_EVENT, THEHUB_POLL_MS } from "./constants";
import { isTheHubStorageKey } from "./store";

const listeners = new Set();
let started = false;
let intervalId = null;

function flush() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      /* keep the bus alive */
    }
  });
}

function start() {
  if (started || typeof window === "undefined") return;
  started = true;
  intervalId = window.setInterval(() => {
    if (typeof document !== "undefined" && document.hidden) return;
    flush();
  }, THEHUB_POLL_MS);
  window.addEventListener("storage", onStorage);
  window.addEventListener(THEHUB_EVENT, flush);
  document.addEventListener("visibilitychange", onVisible);
}

function stop() {
  if (!started) return;
  started = false;
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
  window.removeEventListener("storage", onStorage);
  window.removeEventListener(THEHUB_EVENT, flush);
  document.removeEventListener("visibilitychange", onVisible);
}

function onStorage(event) {
  if (!isTheHubStorageKey(event.key)) return;
  flush();
}

function onVisible() {
  if (typeof document !== "undefined" && document.hidden) return;
  flush();
}

export function useTheHubLive(onChange) {
  const ref = useRef(onChange);
  ref.current = onChange;

  useEffect(() => {
    const listener = () => ref.current?.();
    listeners.add(listener);
    start();
    return () => {
      listeners.delete(listener);
      if (!listeners.size) stop();
    };
  }, []);
}
